import React from 'react';
import { branch, BOOKING_URL, SITE_URL, workingHours } from '../data/siteData';
import { AppStoreIcon, GooglePlayIcon } from './StoreLogos';

const ContactInfo: React.FC = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">

        {/* Header */}
        <div className="section-header">
          <p style={{ fontWeight: 600, fontSize: '0.8rem', color: '#ff1493', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>
            Konum & İletişim
          </p>
          <h2>Bize Ulaşın</h2>
          <div className="section-divider" />
          <p>Velux AVM Batıkent'te sizi bekliyoruz.</p>
        </div>

        {/* Branch card */}
        <div className="branch-card-new">
          <div className="branch-card-inner">

            {/* Info panel */}
            <div className="branch-info-panel">
              <h3 className="branch-name">{branch.name}</h3>

              <div className="branch-info-item">
                <div className="branch-info-icon">📍</div>
                <div>
                  <h4>Adres</h4>
                  <p>{branch.address}</p>
                </div>
              </div>

              <div className="branch-info-item">
                <div className="branch-info-icon">📞</div>
                <div>
                  <h4>Telefon</h4>
                  <a href={`tel:${branch.phonePlain}`}>{branch.phone}</a>
                </div>
              </div>

              <div className="branch-info-item">
                <div className="branch-info-icon">🕐</div>
                <div>
                  <h4>Çalışma Saatleri</h4>
                  <div className="working-hours" role="list">
                    {workingHours.map(({ day, hours }) => (
                      <div key={day} className="working-hours-row" role="listitem">
                        <span className="working-hours-day">{day}</span>
                        <span className="working-hours-eq" aria-hidden="true">=</span>
                        <span className={`working-hours-time${hours === 'Kapalı' ? ' is-closed' : ''}`}>
                          {hours}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="branch-info-item">
                <div className="branch-info-icon" style={{ background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)' }}>💬</div>
                <div>
                  <h4>WhatsApp</h4>
                  <a
                    href={`https://wa.me/${branch.phonePlain}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#25D366', fontWeight: 600, fontSize: '0.9rem' }}
                  >
                    Mesaj Gönder →
                  </a>
                </div>
              </div>

              <div className="branch-actions">
                <a href={branch.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-directions">
                  🗺️ Yol Tarifi Al
                </a>
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-branch">
                  📅 Randevu Al
                </a>
                <a href={`tel:${branch.phonePlain}`} className="btn btn-call">
                  📞 Hemen Ara
                </a>
              </div>
            </div>

            {/* Map */}
            <div className="branch-map-wrapper">
              <iframe
                title="Bloome Beauty Batıkent Harita"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: 420, display: 'block' }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(branch.address)}&output=embed`}
              />
              <div className="map-top-bar">
                <span>{branch.name}</span>
                <a href={branch.mapsUrl} target="_blank" rel="noopener noreferrer">
                  Google Maps'te Aç →
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* App download */}
        <div className="app-download">
          <div className="app-download-inner">
            <div>
              <span className="overline">Mobil Uygulama</span>
              <h3>Bloome'u İndirin</h3>
              <p>Randevu alın, kampanyaları kaçırmayın, işlemlerinizi takip edin.</p>
            </div>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              {[
                { Icon: AppStoreIcon, name: 'App Store', sub: 'Download on the' },
                { Icon: GooglePlayIcon, name: 'Google Play', sub: 'Get it on' },
              ].map(({ Icon, name, sub }) => (
                <a key={name} href={SITE_URL} target="_blank" rel="noopener noreferrer" className="store-btn">
                  <span className="store-icon">
                    <Icon />
                  </span>
                  <div className="store-text">
                    <span className="store-sub">{sub}</span>
                    <span className="store-name">{name}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ContactInfo;
